import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, BodyText, Checkbox } from '@gaiads/telia-react-component-library';
import { LocaleResponse, SalesChannel } from '@cdaas/api-clients/dist/product-service-openapi';

import SalesChannelListItem from './SalesChannelListItem';

interface SalesChannelListProps {
  salesChannels: SalesChannel[];
  tableHeaders: ProductTableHeaders;
  locales: LocaleResponse[];
  selectAll: boolean;
  onSalesChannelChecked: (salesChannel: SalesChannel) => void;
  onAllChecked: () => void;
  isSelected: (product: SalesChannel) => boolean;
}

type TableHeader = string | undefined;
export type ProductTableHeaders = [TableHeader, TableHeader, TableHeader, TableHeader];

export default function SalesChannelList(props: SalesChannelListProps) {
  const { salesChannels, locales, selectAll, tableHeaders, onAllChecked, onSalesChannelChecked, isSelected } = props;

  const { t } = useTranslation('saleschannelsscreen');

  return (
    <Table className={'sales-channels-table'}>
      <thead>
        <Table.Row>
          <Table.HeaderCell type="checkbox">
            <Checkbox
              checked={selectAll}
              onChange={() => {
                onAllChecked();
              }}
              title={t('selectAll')}
            />
          </Table.HeaderCell>
          {tableHeaders.map((header, index) => (
            <Table.HeaderCell key={`table-header-${index}`}>
              <BodyText fontWeight="bold">{header}</BodyText>
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </thead>
      <tbody>
        {salesChannels.map((salesChannel: SalesChannel, index) => {
          return (
            <SalesChannelListItem
              key={`sales-channel-row-${index}`}
              salesChannel={salesChannel}
              locales={locales}
              onSalesChannelChecked={onSalesChannelChecked}
              selected={isSelected(salesChannel)}
            />
          );
        })}
      </tbody>
    </Table>
  );
}
